import { createInertiaApp } from '@inertiajs/react'
import type { ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import AppLayout from '../layouts/AppLayout'
import '@fontsource-variable/fraunces'
import '@fontsource-variable/hanken-grotesk'
import '../styles/application.css'

interface PageModule {
  default: {
    (props: Record<string, unknown>): ReactNode
    layout?: (page: ReactNode) => ReactNode
  }
}

createInertiaApp({
  title: (title) => (title ? `${title} — Tradmusic` : 'Tradmusic'),
  progress: { color: '#16a34a', delay: 250 },
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<
      string,
      PageModule
    >
    const page = pages[`../pages/${name}.tsx`]
    if (!name.startsWith('Sessions/')) {
      page.default.layout =
        page.default.layout || ((page: ReactNode) => <AppLayout>{page}</AppLayout>)
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {})
  })
}
